import { render, staticRenderFns } from "./FinalBreakdown.vue?vue&type=template&id=5a8d07b0"
import script from "./FinalBreakdown.vue?vue&type=script&lang=js"
export * from "./FinalBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports